<template>
  <div class="water-test">
    <!-- <NutrientSummary/> -->
    
    <div class="html2pdf__page-break">
      <MainHeader>
        {{$ml.get('Water test')}}
      </MainHeader>
      
      <GeneralInfo/>
      <NForms/>
      <Nutrients/>
      <Irrigation v-if="section.data.irrigation"/>
    </div>
    <NFormsChart/>
  </div>
</template>

<script>
import NFormsChart from './../components/water-test/NFormsChart';
import GeneralInfo from './../components/water-test/GeneralInfo';
import Irrigation from './../components/water-test/Irrigation';
import NForms from './../components/water-test/NForms';
import Nutrients from './../components/water-test/Nutrients';
import MainHeader from './../components/common/MainHeader';

export default {
  components: {
    MainHeader,
    GeneralInfo,
    Irrigation,
    NForms,
    Nutrients,
    NFormsChart,
  },
  computed: {
    section() {
      return this.$root.data.waterTest;
    }
  },
}
</script>

<style lang="scss" scoped>

.tissue-test {
  .head-line {
    margin-bottom: 10px;
  }
}

</style>